import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_e9jbwwg3he: FaireBrandEntity = {
  token: "b_e9jbwwg3he",
  type: "brand",
  name: "Moonrise Candle Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/60ee03e4d701f446ba44d9f54349db26685e4cbdcdb4b74dd3d4454b2e72f407.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/eaddfc4284ecb2457710e90ef4c8dbe2bac5a9a0095468f35dfb4226f24ef869.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/60ee03e4d701f446ba44d9f54349db26685e4cbdcdb4b74dd3d4454b2e72f407.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/eaddfc4284ecb2457710e90ef4c8dbe2bac5a9a0095468f35dfb4226f24ef869.jpeg",
  location: "Harrisburg, PA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 16,
  isInsider: true,
  description:
    'We are a small batch soy candle company based in Harrisburg, PA. Created in 2015 by Alexander as a high school hobby the company has since grown to serve candle lovers throughout the world with the help of his father, Paul. \n\n"Our goal is to combine natural scents to create simple yet layered aromatic experiences so you can feel your space."\n\nSustainability is a core belief in the Moonrise family. We encourage collaboration and the repurposing of our containers to bridge the gap between community and a healthier planet. The jars can be perfect planters, pen holders, or even brought back to us at any pop-up so we can re-pour a new candle.',
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:23.349Z",
    importedBy: "entity-db-cli",
  },
};
